import { AlarmDetails } from 'queries/notifications/contract';
import { useTranslation } from 'react-i18next';
import './NotificationItem.scss';

export interface NotificationItemProps {
  alarmDetails: AlarmDetails;
}

export const NotificationItem = ({ alarmDetails }: NotificationItemProps) => {
  const { t } = useTranslation();
  return (
    <div className="notification-item-wrapper">
      <span className="notification-item-alarm">
        {t(`components:notifications.alarm_type.${alarmDetails.alarm_field_type}`)}
      </span>
      <span className="notification-item-frequency">
        {alarmDetails.frequencies.map((frequency, index, arr) => (
          <span key={frequency}>
            {t(`components:notifications.frequency.${frequency}`)}
            {index < arr.length - 1 && ', '}
          </span>
        ))}
      </span>
    </div>
  );
};
